interface IAppConst {
  headerHeight: number;
  schoolName: string;
  schoolCode?: string;
  appicationName: string;
  authName: string;
  authDescription: string;
  authCompany: string;
  appicationVersion: string;
  appURLLogo: string;
  APP_URL_PAGE_MAIN: string;

  baseApiURL: string;
  OIDC_AUTHORITY: string;
  OIDC_CLIENT_ID: string;
  OIDC_REDIRECT_URI: string;
  OIDC_CLIENT_SECRET: string;
  OIDC_LOGOUT: string;
  OIDC_UNIT: string;
  OIDC_SCOPE: string;
}
export const appConst: IAppConst = {
  headerHeight: 80,
  schoolName: process.env.REACT_APP_SCHOOL_NAME?.toString() ?? "",
  schoolCode: process.env.REACT_APP_SCHOOL_CODE?.toString() ?? "",
  appicationName: "PHẦN MỀM QUẢN LÝ KẾT QUẢ HỌC TẬP",
  authName: "PHẦN MỀM QUẢN LÝ",
  authDescription: "ĐẠI HỌC SỐ",
  authCompany: "ESSOFT",
  appicationVersion: "1.0.0",
  appURLLogo: process.env.REACT_APP_URL_LOGO && process.env.REACT_APP_URL_LOGO.trim() !== "" ? process.env.REACT_APP_URL_LOGO : `${process.env.REACT_APP_OIDC_AUTHORITY}/logo.png`,
  APP_URL_PAGE_MAIN: process.env.REACT_APP_URL_PAGE_MAIN?.toString() ?? "",
  
  baseApiURL: process.env.REACT_APP_API_BASE_URL?.toString() ?? "",
  OIDC_AUTHORITY: process.env.REACT_APP_OIDC_AUTHORITY?.toString() ?? "",
  OIDC_CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID?.toString() ?? "",
  OIDC_CLIENT_SECRET:process.env.REACT_APP_OIDC_CLIENT_SECRET?.toString() ?? "",
  OIDC_REDIRECT_URI: process.env.REACT_APP_OIDC_REDIRECT_URI?.toString() ?? "",
  OIDC_LOGOUT: process.env.REACT_APP_OIDC_LOGOUT?.toString() ?? "",
  OIDC_UNIT: process.env.REACT_APP_OIDC_UNIT?.toString() ?? "",
  OIDC_SCOPE: process.env.REACT_APP_OIDC_SCOPE?.toString() ?? "",
};
